"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalNav = void 0;

var _base = require("./base");

var _swatches = require("../swatches");

var globalNav = {
  iconActive: _base.primary.brand,
  iconActiveBasic: _base.primary.brand,
  iconActiveBackground: _swatches.monochrome.superLight,
  noticeCountBackground: _base.primary.negative,
  noticeCountColor: _swatches.monochrome.white,
  childrenContainerBackground: _swatches.monochrome.white
};
exports.globalNav = globalNav;
//# sourceMappingURL=globalNav.js.map